import React, { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ThreadedEmail from '../components/email/ThreadedEmail';
import CoPilotChat from '../components/email/CoPilotChat';
import EmailTaskList from '../components/email/EmailTaskList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const EmailTaskContainer = styled.div`
  display: flex;
  height: calc(100vh - 126px);
  background: #f5f5f5;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Header = styled.div`
  background: white;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    border-color: #0066FF;
    color: #0066FF;
  }
`;

const Title = styled.h1`
  margin: 0;
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

const EmailSection = styled.div`
  flex: 1;
  background: white;
  margin: ${props => props.showList ? '0' : '1rem'};
  border-radius: ${props => props.showList ? '0' : '8px'};
  box-shadow: ${props => props.showList ? 'none' : '0 2px 8px rgba(0,0,0,0.1)'};
  overflow: hidden;
`;

const EmailTask = () => {
  const { threadId } = useParams();
  const navigate = useNavigate();
  const [selectedThreadId, setSelectedThreadId] = useState(threadId || null);

  const location = useLocation();

  // try to get the sender name from navigation state (when user clicked a list item)
  const initialThread = location.state?.emailThread;
  const senderFromState = initialThread && Array.isArray(initialThread.messages) && initialThread.messages.length > 0
    ? (initialThread.messages[0].senderName || initialThread.messages[0].customerName || initialThread.messages[0].from)
    : null;

  const handleSelectTask = (task) => {
    // derive an id for the url
    const threadKey = task.emailThreadId || task.threadId || (task.id ? String(task.id) : null);
    setSelectedThreadId(threadKey);
    // Pass the whole task object in navigation state so detail page can render it
    navigate(`/email-task/${threadKey}`, { state: { emailThread: task } });
  };

  const handleBackToList = () => {
    setSelectedThreadId(null);
    navigate('/email-task');
  };

  const showList = !selectedThreadId;

  return (
      <MainContent>
        {!showList && (
          <Header>
            <BackButton onClick={handleBackToList}>
              <FontAwesomeIcon icon={faArrowLeft} />
              Back to List
            </BackButton>
            <Title>
              {senderFromState ? `From ${senderFromState}` : `Email Thread: ${selectedThreadId}`}
            </Title>
          </Header>
        )}
        <ContentArea>
          <EmailSection showList={showList}>
            {showList ? (
              <EmailTaskList onSelectTask={handleSelectTask} />
            ) : (
              <ThreadedEmail threadId={selectedThreadId} initialThread={location.state?.emailThread} />
            )}
          </EmailSection>
        </ContentArea>
      </MainContent>
  );
};

export default EmailTask;
